var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 53,
    viewBox: "0 0 90 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.e{fill:#fff;}.a{stroke:#dadada;stroke-miterlimit:10;}.b,.f,.h{fill:none;}.b{stroke:#d3d3d3;}.c,.d,.f{stroke:#0072c6;}.c,.d{stroke-width:2px;}.d{fill:#0072c6;}.e{stroke:#c4c4c4;stroke-width:0.5px;}.g{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16342 24425)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-16342 -24425)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 90,
    height: 53,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 52,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 70,
    transform: "translate(-16333.238 -24415.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-16334 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.008,
    cy: 3.008,
    r: 3.008
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.008,
    cy: 3.008,
    r: 2.008
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-16302.207 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-16319.75 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-16284.293 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-16267.293 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-16335 -24408)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 75,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.25,
    y: 0.25,
    width: 74.5,
    height: 30.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 5,
    transform: "translate(-16319.109 -24410.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle2);
export default __webpack_public_path__ + "static/media/style2.067b296179552529f0580323afa71d30.svg";
export { ForwardRef as ReactComponent };